export default __webpack_public_path__ + "af62c27164b84fa93fa294206a48249b.png";